import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";

export default function LabelFieldComponent({ label, labelDir, fieldSize, option, type, placeholder, value, loading, onSelectChange, ...rest }) {
    const { t } = useContext(TranslatorContext)
    return (
        <div className={`mc-label-field-group ${ label ? labelDir || "label-col" : "" }`}>
            {label && <label className="mc-label-field-title">{ t(label) }</label>}
            {type ? 
                <input 
                    type = { type || "text" } 
                    placeholder = { placeholder || t('type_here') } 
                    className = {`mc-label-field-input ${ fieldSize || "w-md h-sm" }`} 
                    /* #120936 — `value` bị destructure ở trên nhưng TRƯỚC ĐÂY chỉ được gắn cho nhánh
                       <select>, nên ô <input> luôn là uncontrolled: trang truyền `value` vào cũng
                       không hiện. Lộ ra khi deep-link `?search=`: dữ liệu đã lọc đúng nhưng ô tìm
                       kiếm trống trơn. Chỉ gắn khi trang thực sự truyền `value` để các trang đang
                       dùng ô không kiểm soát giữ nguyên hành vi cũ. */
                    { ...(value !== undefined ? { value } : {}) }
                    { ...rest } 
                />
            :
                <>
                    <select 
                        style={{ backgroundImage: 'url(/images/dropdown.svg)' }} 
                        className={`mc-label-field-select ${ fieldSize || "w-md h-sm" }`} 
                        value={value}
                        onChange={onSelectChange}
                        disabled={loading}
                        { ...rest }
                    >
                        {loading ? (
                            <option value="">{t('loading')}...</option>
                        ) : (
                            option.map((item, index) => (
                                <option key={ index } value={ item }>{t(item)}</option>
                            ))
                        )}
                    </select>
                </>
            }
        </div>
    )
}
